module.exports = __webpack_public_path__ + "static/media/lucas-delboni.22d57be8.jpg";